// extracted by mini-css-extract-plugin
export default {"readOnly":"styles_readOnly__4GtkZ"};